// extracted by mini-css-extract-plugin
export var container = "_8r-0";
export var icon = "_8r-1";
export var text = "_8r-2";